import { render, staticRenderFns } from "./OrthographiqWeeklyLeaderBoard.vue?vue&type=template&id=41e91abb&scoped=true&"
import script from "./OrthographiqWeeklyLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./OrthographiqWeeklyLeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./OrthographiqWeeklyLeaderBoard.vue?vue&type=style&index=0&id=41e91abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e91abb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
